import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CancelIcon from '@mui/icons-material/Cancel';
import Edit from '@mui/icons-material/Edit';
import SegredoJustica from '@mui/icons-material/Lock';
import VerticalAlignBottom from '@mui/icons-material/VerticalAlignBottom';
import VerticalAlignTop from '@mui/icons-material/VerticalAlignTop';
import { default as Warning } from '@mui/icons-material/Warning';
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogTitle,
    Divider,
    Fab,
    Paper,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { SITUACAO_CERTIDAO } from '../../dominio/SituacaoCertidao';
import BusinessError from '../../util/BusinessError';
import Configuracao from '../../util/Configuracao';
import ErrorUtil from '../../util/ErrorUtil';
import ModoAssinatura from '../assinatura/ModoAssinatura';
import ModalCertidaoOperacaoLote from '../certidao/ModalCertidaoOperacaoLote';
import IconeOrigem from '../IconeOrigem';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import ModalComposicao from './ModalComposicao';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';

const TAG_RESUMO = '##RESUMO';
const TAG_DECISAO = '##DECISAO';
const TAG_PARTES = '##PARTES';
const TAMANHO_CHAVE_OTP = 6;
const TAMANHO_MAXIMO_LOTE = 100;

class AssinarLote extends ReactComponent {
    carregandoCertidao = false;
    modalComposicaoOpen = false;
    registroComposicao;
    dialogOpen = false;
    certidao = undefined;
    cabecalho = '';
    resumo = '';
    decisao = '';
    partes = '';
    rascunho = '';
    rodape = '';
    divResumoDecisao = '';
    divPartes = '';
    numeroProcessoClicado = undefined;
    registroSelecionado = undefined;
    processandoAssinaturas = false;
    modalChaveOtpOpen = false;
    registroModalCertidao;

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoCertidao: observable,
            modalComposicaoOpen: observable,
            registroComposicao: observable,
            dialogOpen: observable,
            certidao: observable,
            cabecalho: observable,
            resumo: observable,
            decisao: observable,
            partes: observable,
            rascunho: observable,
            rodape: observable,
            divResumoDecisao: observable,
            divPartes: observable,
            numeroProcessoClicado: observable,
            registroSelecionado: observable,
            processandoAssinaturas: observable,
            modalChaveOtpOpen: observable,
            registroModalCertidao: observable,
            processosPendentesAssinaturaHabilitadosParaAbrirCertidao: computed,
            listaProcessosSelecionados: computed,
            sessao: computed,
            processosPendentesAssinatura: computed,
            limparProcessoPesquisa: action,
            processosSelecionaveis: computed,
            botaoAssinarDesabilitado: computed,
            botaoCertidaoAnteriorDisabled: computed,
            botaoProximaCertidaoDisabled: computed,
            handleClickAssinatura: action,
            handleCloseDialog: action,
            handleClickProcesso: action,
            marcarLinha: action,
            desmarcarLinha: action,
            carregarCamposCertidao: action,
            handleSelecionarProcesso: action,
            handleAssinar: action,
            existeProcessoPJeSelecionado: computed,
            existeProcessoSIJSelecionado: computed,
            callbackCancelar: action,
            callbackContinuarAssinaturaOtp: action,
            tratarResultadoAssinaturaOtpLote: action,
            atualizarProcessoAssinadoTransferido: action,
            atualizarProcessos: action,
            callbackFecharModalCertidao: action,
            abrirModalCertidao: action,
            handleClickWarningCertidao: action,
            handleCloseModalComposicao: action,
            up: action,
            down: action
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen,
                () => this.limparProcessoPesquisa()
            )
        );
    }

    handleKeyDown = (e) => {
        if (e.shiftKey && e.key === 'ArrowUp') {
            this.up();
        } else if (e.shiftKey && e.key === 'ArrowDown') {
            this.down();
        }
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    get listaProcessosSelecionados() {
        return this.processosPendentesAssinatura.filter(
            (registro) => this.store.isCheckedOperacoesEmLote(registro) && !this.existeAlerta(registro)
        );
    }

    get sessao() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get processosPendentesAssinatura() {
        let retorno = this.salaSessaoStore.filtros.filtroCertidaoPendente.filtrar(
            this.salaSessaoStore.processosApreciadosFiltrados,
            SITUACAO_CERTIDAO.NAO_ASSINADA.id
        );
        retorno = retorno.filter((registro) => this.filtrarProcessoPeloNumero(registro));
        return retorno;
    }

    get processosPendentesAssinaturaHabilitadosParaAbrirCertidao() {
        return this.processosPendentesAssinatura.filter((registro) => !this.desabilitarAbrirCertidao(registro));
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get processosSelecionaveis() {
        return this.processosPendentesAssinatura.filter((registro) => !this.existeAlerta(registro));
    }

    get botaoAssinarDesabilitado() {
        return this.processandoAssinaturas;
    }

    handleClickAssinatura = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
        this.registroSelecionado = undefined;
        this.registroModalCertidao = undefined;
        this.numeroProcessoClicado = undefined;
    };

    handleClickProcesso = async (registro) => {
        this.carregandoCertidao = true;
        await this.salaSessaoStore.carregarDetalhesProcesso(registro);
        runInAction(() => {
            this.numeroProcessoClicado = registro.processo.numeroCompleto;
            this.registroSelecionado = registro;
        });
        let certidaoJSON = await this.certidaoService.recuperarCamposCertidao(
            registro,
            this.sessao.orgaoJudicante.sigla,
            this.sessao.orgaoJudicante.descricao,
            this.sessao.tipoJulgamento
        );
        if (!certidaoJSON) {
            await this.salaSessaoStore.carregarRascunhoCertidao(registro);
            certidaoJSON = await this.criarCertidaoPadrao(registro);
        }
        if (certidaoJSON) {
            this.carregarCamposCertidao(certidaoJSON);
            runInAction(() => (registro.certidaoGerada = true));
        }
        runInAction(() => (this.carregandoCertidao = false));
    };

    async criarCertidaoPadrao(registro) {
        let retorno;
        try {
            let cpfSignatario = this.dominioStore.temSignatariosCadastradosOjc(this.sessao.orgaoJudicante.sigla)
                ? this.dominioStore.signatarioCadastradoDefaultOjc(this.sessao.orgaoJudicante.sigla).cpf
                : this.usuarioStore.usuario.cpf;
            retorno = await this.certidaoService.criarCertidaoPadrao(
                this.sessao,
                registro,
                registro.rascunhoCertidao,
                null,
                cpfSignatario
            );
        } catch (error) {
            if (error instanceof BusinessError) {
                this.mensagemStore.abrirMensagemErro(error.message);
            }
        }
        return retorno;
    }

    marcarLinha = (registro) => {
        registro.linha = true;
    };

    desmarcarLinha = (registro) => {
        registro.linha = false;
    };

    carregarCamposCertidao = (certidaoJSON) => {
        if (certidaoJSON) {
            let certidao = document.createElement('div');
            certidao.innerHTML = certidaoJSON.conteudoCompleto;
            this.cabecalho = certidao.children[0].querySelector('#cabecalho').outerHTML;
            this.resumo = certidaoJSON.resumo;
            this.decisao = certidaoJSON.decisao;
            this.divResumoDecisao = certidao.children[0]
                .querySelector('#resumo-e-decisao')
                .outerHTML.replace(this.resumo, TAG_RESUMO)
                .replace(this.decisao, TAG_DECISAO);
            this.partes = certidaoJSON.partes;
            this.divPartes = certidao.children[0].querySelector('#partes').outerHTML.replace(this.partes, TAG_PARTES);
            this.rodape = certidao.children[0].querySelector('#rodape').outerHTML;
        }
    };

    handleSelecionarProcesso = (registro) => {
        this.store.toggleCheckedOperacoesEmLote(registro);
    };

    handleAssinar = async () => {
        this.processandoAssinaturas = true;

        try {
            if (this.listaProcessosSelecionados.length > 0) {
                await this.assinarCertidoes();
                runInAction(() => (this.registroSelecionado = undefined));
            } else {
                this.mensagemStore.abrirMensagemAlerta('Selecione um ou mais processos');
            }
        } catch (error) {
            console.error(error);
            if (error instanceof BusinessError) {
                this.mensagemStore.abrirMensagemAlerta(error.message);
                runInAction(() => (this.salaSessaoStore.dialogProgressoProcessamentoLote = false));
            } else {
                this.mensagemStore.abrirMensagemErro(error.message);
            }
        } finally {
            runInAction(() => {
                this.processandoAssinaturas = false;
            });
        }
    };

    async assinarCertidoes() {
        this.salaSessaoStore.inicializarProcessamentoLote(
            this.listaProcessosSelecionados.length,
            'Assinando certidões',
            true
        );

        if (this.existeProcessoPJeSelecionado && this.sessaoStore.modoAssinatura === Configuracao.MODO_ASSINATURA_JTE) {
            this.modalChaveOtpOpen = true;
        } else {
            let resultadoProcessamento = await this.assinarCertidoesSemOtp(this.listaProcessosSelecionados);

            if (this.salaSessaoStore.finalizarProcessamentoLote(resultadoProcessamento)) {
                this.mensagemStore.abrirMensagemSucesso('Operação realizada com sucesso.');
            } else {
                console.error('Falha na operação [ assinarCertidoesSemOtp() ].');
            }
        }
    }

    get existeProcessoPJeSelecionado() {
        return (
            this.listaProcessosSelecionados &&
            this.listaProcessosSelecionados.findIndex(
                (registro) => registro.processo.origem === Configuracao.ORIGEM_PJE
            ) !== -1
        );
    }

    get existeProcessoSIJSelecionado() {
        return (
            this.listaProcessosSelecionados &&
            this.listaProcessosSelecionados.findIndex(
                (registro) => registro.processo.origem === Configuracao.ORIGEM_SIJ
            ) !== -1
        );
    }

    callbackCancelar = () => {
        this.modalChaveOtpOpen = false;
        this.salaSessaoStore.dialogProgressoProcessamentoLote = false;
    };

    callbackContinuarAssinaturaOtp = async (chaveOtp) => {
        this.modalChaveOtpOpen = false;

        if (chaveOtp?.length !== TAMANHO_CHAVE_OTP) {
            this.mensagemStore.abrirMensagemAlerta('Código de autorização JTe inválido.');
            return;
        }

        let resultadoProcessamento = (await this.assinarCertidoesPJeOtp(chaveOtp)) || [];
        resultadoProcessamento = resultadoProcessamento.concat(await this.assinarCertidoesSIJ());

        if (this.salaSessaoStore.finalizarProcessamentoLote(resultadoProcessamento)) {
            this.mensagemStore.abrirMensagemSucesso('Operação realizada com sucesso.');
        } else {
            console.error('Falha na operação [ assinarCertidoesPJeOtp() ].');
        }
    };

    async assinarCertidoesSIJ() {
        let resultadoProcessamento = [];

        if (this.existeProcessoSIJSelecionado) {
            resultadoProcessamento = await this.assinarCertidoesSemOtp(
                this.listaProcessosSelecionados.filter(
                    (registro) => registro.processo.origem === Configuracao.ORIGEM_SIJ
                )
            );
        }

        return resultadoProcessamento;
    }

    async assinarCertidoesPJeOtp(chaveOtp) {
        let processos = this.listaProcessosSelecionados
            .filter((registro) => registro.processo.origem === Configuracao.ORIGEM_PJE)
            .map((registro) => ({
                numeroProcesso: registro.processo.numeroCompleto,
                sessaoId: registro.sessaoId,
                tipoJulgamento: registro.tipoJulgamento
            }));
        let resultadoProcessamento = await this.assinaturaService.assinarCertidoesOtp(
            processos,
            this.sessao.id,
            this.sessao.tipoJulgamento,
            this.sessao.orgaoJudicante,
            chaveOtp
        );
        this.salaSessaoStore.atualizarProcessamentoLote(resultadoProcessamento);
        this.tratarResultadoAssinaturaOtpLote(resultadoProcessamento);
        return resultadoProcessamento;
    }

    tratarResultadoAssinaturaOtpLote(resultadoProcessamento) {
        resultadoProcessamento.forEach((resultado) => {
            if (resultado && !ErrorUtil.isResultadoErro(resultado)) {
                this.atualizarProcessoAssinadoTransferido(resultado.elemento.numeroProcesso);
            }
        });
    }

    atualizarProcessoAssinadoTransferido(numeroProcesso) {
        let registro = this.listaProcessosSelecionados.find((reg) => reg.processo.numeroCompleto === numeroProcesso);

        if (registro) {
            registro.certidaoJulgamentoAssinada = true;
            registro.certidaoJulgamentoTransferida = true;
            registro.informacoesAdicionais.permitirQuebraAssinaturaCertidao = true;
        }
    }

    async assinarCertidoesSemOtp(processos) {
        let resultadoProcessamento = [];
        let resultado;
        let mapaSessaoNumerosProcessos = this.getMapaSessaoProcessoAssinatura(processos);

        for (let sessaoId of mapaSessaoNumerosProcessos.keys()) {
            let numerosCompletos = mapaSessaoNumerosProcessos.get(sessaoId);

            if (this.salaSessaoStore.isSessaoSIJ(sessaoId)) {
                resultado = await this.assinaturaService.assinarSIJ(
                    numerosCompletos,
                    sessaoId,
                    this.sessao.orgaoJudicante,
                    this.sessao.tipoJulgamento,
                    true
                );
            } else {
                resultado = await this.assinaturaService.assinarPje(
                    numerosCompletos,
                    sessaoId,
                    this.sessao.orgaoJudicante,
                    this.sessao.tipoJulgamento,
                    true
                );
            }
            resultadoProcessamento = resultadoProcessamento.concat(resultado);
            this.salaSessaoStore.atualizarProcessamentoLote(resultado);
            this.atualizarProcessos(resultadoProcessamento);
        }

        return resultadoProcessamento;
    }

    getMapaSessaoProcessoAssinatura(processos) {
        let mapaSessaoNumerosProcessos = new Map();
        //organiza os processos por sessão
        processos.forEach((reg) => {
            let numeros = mapaSessaoNumerosProcessos.get(reg.sessaoId);
            let processoAssinatura = {
                numeroProcesso: reg.processo.numeroCompleto,
                tipoJulgamento: reg.tipoJulgamento
            };
            if (!numeros) {
                mapaSessaoNumerosProcessos.set(reg.sessaoId, [processoAssinatura]);
            } else {
                numeros.push(processoAssinatura);
            }
        });
        return mapaSessaoNumerosProcessos;
    }

    atualizarProcessos(resultadoProcessamento) {
        resultadoProcessamento.forEach((resultado) => {
            if (resultado && !ErrorUtil.isResultadoErro(resultado)) {
                let registro = this.processosPendentesAssinatura.find((reg) => {
                    if (reg?.processo?.numeroCompleto && resultado.elemento) {
                        return reg.processo.numeroCompleto === resultado.elemento;
                    }
                    return false;
                });
                if (registro) {
                    registro.certidaoJulgamentoAssinada = true;
                }
            }
        });
    }

    renderConteudoCertidao() {
        if (!this.registroSelecionado) {
            return null;
        }
        if (this.carregandoCertidao) {
            return (
                <div style={{ display: 'flex', flexGrow: '1', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '20px ' }}>
                        <CircularProgress />
                        <Typography
                            variant="h6"
                            style={{ margin: '20px' }}
                        >
                            Carregando certidão
                        </Typography>
                    </div>
                </div>
            );
        }
        return (
            <div
                style={{
                    display: 'flex',
                    flexGrow: '1',
                    flexDirection: 'column',
                    margin: '20px',
                    textAlign: 'justify'
                }}
            >
                <div dangerouslySetInnerHTML={{ __html: this.cabecalho }}></div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: this.divResumoDecisao
                            .replace(TAG_RESUMO, this.resumo)
                            .replace(TAG_DECISAO, this.decisao)
                    }}
                ></div>
                <div dangerouslySetInnerHTML={{ __html: this.divPartes.replace(TAG_PARTES, this.partes) }}></div>
                {!this.salaSessaoStore.isProcessoPje(this.registroSelecionado) && (
                    <div dangerouslySetInnerHTML={{ __html: this.rodape }}></div>
                )}
                <div style={{ position: 'absolute', bottom: '74px', right: '43px' }}>
                    <Fab
                        color="primary"
                        onClick={this.abrirModalCertidao}
                    >
                        <Edit />
                    </Fab>
                </div>
            </div>
        );
    }

    callbackFecharModalCertidao = (registro) => {
        if (
            this.processosPendentesAssinatura.findIndex(
                (reg) => reg.processo.numeroCompleto === registro.processo.numeroCompleto
            ) !== -1
        ) {
            this.handleClickProcesso(registro);
        } else {
            this.registroSelecionado = undefined;
        }
        this.registroModalCertidao = undefined;
    };

    abrirModalCertidao = () => {
        this.registroModalCertidao = this.registroSelecionado;
    };

    desabilitarMovimentosNaoTransferidos(registro) {
        return (
            this.isComponenteHabilitado('ModoAssinatura') &&
            this.sessaoStore.modoAssinatura === Configuracao.MODO_ASSINATURA_JTE &&
            registro.processo.origem === Configuracao.ORIGEM_PJE &&
            !registro.movimentosTransferidos
        );
    }

    desabilitarAbrirCertidao(registro) {
        return !this.existeRelatorComposicao(registro) || !this.existePresidenteComposicao(registro);
    }

    existeAlerta(registro) {
        return (
            !this.existeRelatorComposicao(registro) ||
            !this.existePresidenteComposicao(registro) ||
            !this.existeCertidao(registro) ||
            this.desabilitarMovimentosNaoTransferidos(registro)
        );
    }

    existeCertidao(registro) {
        return !!registro?.certidaoGerada;
    }

    existeRelatorComposicao(registro) {
        return (
            registro?.processo?.relator &&
            registro.composicao.findIndex((composicao) => composicao.magistrado.cpf === registro.processo.relator.cpf) >
                -1
        );
    }

    existePresidenteComposicao(registro) {
        return (
            registro &&
            registro.composicao.findIndex(
                (composicao) =>
                    !composicao.magistrado.impedido &&
                    !composicao.magistrado.ausente &&
                    composicao.magistrado.presidenteSessao === true
            ) > -1
        );
    }

    isObedeceQuorumComposicao(registro) {
        let magistrados = 0;
        for (let comp of registro?.composicao ? registro.composicao : []) {
            if (!this.isImpedido(registro, comp.magistrado.sigla)) {
                magistrados++;
            }
        }
        return magistrados >= this.sessaoStore.sessaoSelecionada.quorum;
    }

    isImpedido(registro, sigla) {
        return (
            registro.impedimentos &&
            registro.impedimentos.findIndex((impedimento) => impedimento.magistrado.sigla === sigla) !== -1
        );
    }

    alertasComposicaoTooltipTitle(registro) {
        return (
            <div>
                <div>Não é possível assinar certidão de processo:</div>
                <ul style={{ listStyleType: 'circle' }}>
                    {!this.existeRelatorComposicao(registro) && (
                        <li>Sem relator na composição. Clique para alterar a composição.</li>
                    )}
                    {!this.existeCertidao(registro) && (
                        <li>Sem o documento da certidão. Clique para gerar a certidão padrão.</li>
                    )}
                    {!this.existePresidenteComposicao(registro) && (
                        <li>Sem presidente na composição. Clique para alterar a composição.</li>
                    )}
                    {this.desabilitarMovimentosNaoTransferidos(registro) && (
                        <li>Sem movimentos transferidos para o PJe (Assinatura e envio com JTe).</li>
                    )}
                </ul>
            </div>
        );
    }

    handleClickWarningCertidao = async (registro) => {
        if (!this.existeRelatorComposicao(registro) || !this.existePresidenteComposicao(registro)) {
            this.registroComposicao = registro;
            this.modalComposicaoOpen = true;
        } else if (!this.existeCertidao(registro)) {
            await this.handleClickProcesso(registro);
        }
    };

    handleCloseModalComposicao = () => {
        this.registroComposicao = this.salaSessaoStore.processosSessao.find(
            (registro) => registro.numeroProcesso === this.registroComposicao.numeroProcesso
        );

        if (
            this.existeRelatorComposicao(this.registroComposicao) &&
            this.existePresidenteComposicao(this.registroComposicao) &&
            this.isObedeceQuorumComposicao(this.registroComposicao) &&
            !this.existeCertidao(this.registroComposicao)
        ) {
            this.handleClickProcesso(this.registroComposicao);
        }

        runInAction(() => {
            this.modalComposicaoOpen = false;
            this.registroComposicao = undefined;
        });
    };

    get botaoCertidaoAnteriorDisabled() {
        return (
            this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao.length === 0 ||
            this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao[0]?.processo?.numeroCompleto ===
                this.registroSelecionado?.processo?.numeroCompleto
        );
    }

    get botaoProximaCertidaoDisabled() {
        return (
            this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao.length === 0 ||
            this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao[
                this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao.length - 1
            ]?.processo?.numeroCompleto === this.registroSelecionado?.processo?.numeroCompleto
        );
    }

    buscarIndiceRegistroSelecionado() {
        // @ts-ignore
        return this.processosPendentesAssinatura.findIndex(
            (registro) => registro.processo.numeroCompleto === this.registroSelecionado.processo?.numeroCompleto
        );
    }

    scrollLista(registro) {
        const elementoRegistro = document.getElementById(`processoAssinarLote-${registro.processo.numeroCompleto}`);
        if (elementoRegistro) {
            elementoRegistro.scrollIntoView();
        }
    }

    up = async () => {
        let proximoRegistro;
        if (this.registroSelecionado) {
            const indiceRegistroSelecionado = this.buscarIndiceRegistroSelecionado();
            if (this.buscarIndiceRegistroSelecionado() > 0) {
                proximoRegistro =
                    this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao[indiceRegistroSelecionado - 1];
            }
        } else {
            proximoRegistro =
                this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao[
                    this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao.length - 1
                ];
        }

        if (proximoRegistro) {
            await this.handleClickProcesso(proximoRegistro);
            this.scrollLista(proximoRegistro);
        }
    };

    down = async () => {
        let registroAnterior;
        if (this.registroSelecionado) {
            const indiceRegistroSelecionado = this.buscarIndiceRegistroSelecionado();
            if (
                this.buscarIndiceRegistroSelecionado() <
                this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao.length - 1
            ) {
                registroAnterior =
                    this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao[indiceRegistroSelecionado + 1];
            }
        } else {
            registroAnterior = this.processosPendentesAssinaturaHabilitadosParaAbrirCertidao[0];
        }

        if (registroAnterior) {
            await this.handleClickProcesso(registroAnterior);
            this.scrollLista(registroAnterior);
        }
    };

    render() {
        if (!this.parametroStore.usaCertidao()) {
            return null;
        }

        return (
            <div>
                {this.renderIcone()}
                {this.dialogOpen && (
                    <Dialog
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                        slotProps={{
                            paper: {
                                sx: { height: '100%' }
                            }
                        }}
                    >
                        {this.renderDialogTitle()}
                        <OperacoesEmLoteSelecionar
                            processosSelecionaveis={this.processosSelecionaveis}
                            processos={this.processosPendentesAssinatura}
                            exibirBotaoSelecaoProximos={true}
                            quantidadeSelecaoProximos={TAMANHO_MAXIMO_LOTE}
                            desabilitarBotaoSelecionarTodos={true}
                            mensagemDesabilitacaoBotaoSelecionarTodos="Funcionalidade temporariamente desabilitada para evitar inconsistências nas informações de assinatura de certidões do PJe."
                        />
                        <div
                            style={{
                                display: 'flex',
                                flexGrow: '1',
                                margin: '0px 20px',
                                height: 'calc(100% - 200px)'
                            }}
                        >
                            {this.renderListaProcessos()}
                            <Paper
                                elevation={10}
                                style={{
                                    display: 'flex',
                                    flexGrow: '1',
                                    marginLeft: '10px',
                                    overflowY: 'auto',
                                    height: '100%'
                                }}
                            >
                                {this.renderConteudoCertidao()}
                            </Paper>
                            {this.modalComposicaoOpen && (
                                <ModalComposicao
                                    open={true}
                                    registro={this.registroComposicao}
                                    onClose={this.handleCloseModalComposicao}
                                />
                            )}
                        </div>
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Fechar
                            </Button>
                            <Button
                                onClick={this.handleAssinar}
                                color="primary"
                                variant="outlined"
                                endIcon={
                                    <FontAwesomeIcon
                                        icon={faFileSignature}
                                        style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                                    />
                                }
                                disabled={this.botaoAssinarDesabilitado}
                            >
                                Assinar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
                <ModalCertidaoOperacaoLote
                    registro={this.registroModalCertidao}
                    open={this.registroModalCertidao !== undefined}
                    callbackClose={(registro) => this.callbackFecharModalCertidao(registro)}
                />
            </div>
        );
    }

    classNameLinhaProcesso(registro) {
        let retorno = 'linhaProcesso';
        const estaExpandido =
            this.numeroProcessoClicado && this.numeroProcessoClicado === registro.processo.numeroCompleto;

        if (estaExpandido) {
            retorno = 'processoExpandido';
        }

        return retorno;
    }

    renderListaProcessos() {
        return (
            <Paper
                elevation={10}
                style={{ height: '100%' }}
            >
                <div style={{ overflowY: 'auto', height: '100%', minWidth: '400px' }}>
                    {this.processosPendentesAssinatura && this.processosPendentesAssinatura.length > 0 ? (
                        this.processosPendentesAssinatura.map((registro) => (
                            <div
                                id={'processoAssinarLote-' + registro.processo.numeroCompleto}
                                key={'PPA-' + registro.processo.numeroCompleto}
                                style={{ display: 'flex', flexDirection: 'column' }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row'
                                    }}
                                    className={this.classNameLinhaProcesso(registro)}
                                    onMouseEnter={this.marcarLinha}
                                    onMouseLeave={this.desmarcarLinha}
                                >
                                    {this.renderCheckbox(registro)}
                                    <Box
                                        style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
                                        onClick={
                                            !this.desabilitarAbrirCertidao(registro)
                                                ? this.handleClickProcesso.bind(this, registro)
                                                : undefined
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                fontSize: '11pt',
                                                color: registro.segredoJustica ? 'red' : '',
                                                margin: '8px',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {registro.processo.numeroCompleto} {this.renderSegredoJustica(registro)}
                                            </div>
                                            {this.parametroStore.isOrgaoTST && (
                                                <IconeOrigem processo={registro.processo} />
                                            )}
                                        </div>
                                        <div style={{ margin: '0px 8px 8px' }}>
                                            <IconesMagistradosProcesso registro={registro} />
                                        </div>
                                    </Box>
                                </div>
                                <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} />
                            </div>
                        ))
                    ) : (
                        <Typography
                            variant="h6"
                            style={{ margin: '20px' }}
                        >
                            {'Não há processos com certidão pendente de assinatura na sessão'}
                        </Typography>
                    )}
                </div>
            </Paper>
        );
    }

    renderSegredoJustica(registro) {
        if (!registro?.segredoJustica) {
            return null;
        }

        return (
            <SegredoJustica
                style={{
                    height: '16px',
                    width: '16px',
                    marginLeft: '4px',
                    marginBottom: '4px'
                }}
            />
        );
    }

    renderCheckbox(registro) {
        return !this.existeAlerta(registro) ? (
            <Checkbox
                checked={this.store.isCheckedOperacoesEmLote(registro)}
                onChange={this.handleSelecionarProcesso.bind(this, registro)}
            />
        ) : (
            <Tooltip title={this.alertasComposicaoTooltipTitle(registro)}>
                <Warning
                    style={{ margin: '16px 12px', fill: 'darkorange' }}
                    onClick={() => this.handleClickWarningCertidao(registro)}
                />
            </Tooltip>
        );
    }

    renderDialogTitle() {
        return (
            <DialogTitle
                id="simple-dialog-title"
                style={{ padding: '16px 24px 0px' }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h4 style={{ margin: '0px' }}>Assinar em lote</h4>
                    </div>
                    <div style={{ margin: '0px 10px' }}>
                        <NumeroProcesso
                            dense
                            tooltip="Número do processo a ser pesquisado na listagem"
                            callbackOnChange={this.callbackNumeroProcesso}
                            clickLimpar={this.limparProcessoPesquisa}
                        />
                    </div>
                    <ModoAssinatura
                        modalChaveOtpOpen={this.modalChaveOtpOpen}
                        callbackCancelar={this.callbackCancelar}
                        callbackContinuarAssinaturaOtp={this.callbackContinuarAssinaturaOtp}
                        processos={this.processosPendentesAssinatura}
                    />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip
                            title={
                                this.botaoCertidaoAnteriorDisabled
                                    ? ''
                                    : 'Abrir certidão anterior (Shift + ' + String.fromCharCode(0x25b2) + ')'
                            }
                        >
                            <div>
                                <Button
                                    style={{ minWidth: '24px', padding: '4px 8px' }}
                                    onClick={this.up}
                                    disabled={this.botaoCertidaoAnteriorDisabled}
                                >
                                    <VerticalAlignTop />
                                </Button>
                            </div>
                        </Tooltip>
                        <Tooltip
                            title={
                                this.botaoProximaCertidaoDisabled
                                    ? ''
                                    : 'Abrir próxima certidão (Shift + ' + String.fromCharCode(0x25bc) + ')'
                            }
                        >
                            <div>
                                <Button
                                    style={{ minWidth: '24px', padding: '4px 8px' }}
                                    onClick={this.down}
                                    disabled={this.botaoProximaCertidaoDisabled}
                                >
                                    <VerticalAlignBottom />
                                </Button>
                            </div>
                        </Tooltip>
                        <div style={{ display: 'flex', alignItems: 'center', margin: '10px', paddingTop: '5px' }}>
                            <PainelFiltros />
                        </div>
                        <FiltroRapido id="filtroRapidoAssinarLote" />
                    </div>
                </div>
            </DialogTitle>
        );
    }

    renderIcone() {
        return (
            <div
                style={{ marginRight: '10px' }}
                className="corBotao"
            >
                <Tooltip
                    title={'Assinar certidões em lote'}
                    placement="top-start"
                >
                    <span>
                        <FontAwesomeIcon
                            icon={faFileSignature}
                            onClick={this.handleClickAssinatura}
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                        />
                    </span>
                </Tooltip>
            </div>
        );
    }
}

export default inject('stores')(observer(AssinarLote));
